import { UserChatBotHistory } from '@/Workspaces/ChatBotHistory/UserChatBotHistory'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
    '/workspace/$workspaceId/botProvider/$botProviderId/user/$userId',
)({
    component: RouteComponent,
})

function RouteComponent() {
    return (
        <UserChatBotHistory />
    )
}
